import React, { useState, useEffect } from 'react';
import landingPageAPI from '../../services/api';
import './ContactInfo.css';

const ContactInfo = () => {
  const [contactInfo, setContactInfo] = useState({
    email_primary: 'contact@haazri.net',
    email_secondary: 'contact@webwiings.com',
    phone: '+92 300 1234567',
    website: 'www.haazri.net',
    address: '123 Business Street, Karachi, Pakistan'
  });
  const [title, setTitle] = useState('Get In Touch');
  const [subtitle, setSubtitle] = useState('We\'re here to help and answer any questions you may have');

  useEffect(() => {
    fetchContactInfo();
  }, []);

  const fetchContactInfo = async () => {
    try {
      const response = await landingPageAPI.getAllContent();
      if (response.data.status === 'success') {
        const config = response.data.data.config || {};

        // Extract contact information from config
        const contactData = {
          email_primary: config.contact_email_primary || 'contact@haazri.net',
          email_secondary: config.contact_email_secondary || 'contact@webwiings.com',
          phone: config.contact_phone || '+92 300 1234567',
          website: config.contact_website || 'www.haazri.net',
          address: config.contact_address || '123 Business Street, Karachi, Pakistan'
        };

        setContactInfo(contactData);

        // Check for custom title/subtitle
        const sections = response.data.data.sections || [];
        const contactSection = sections.find(s => s.section_key === 'contact');

        if (contactSection && contactSection.content) {
          const titleContent = contactSection.content.find(c => c.content_key === 'contact_title');
          const subtitleContent = contactSection.content.find(c => c.content_key === 'contact_subtitle');

          if (titleContent) setTitle(titleContent.content_value);
          if (subtitleContent) setSubtitle(subtitleContent.content_value);
        }
      }
    } catch (error) {
      console.error('Failed to fetch contact info:', error);
    }
  };

  return (
    <section className="contact-info" id="contact">
      <div className="container">
        <div className="section-title">
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </div>

        <div className="contact-grid">
          <div className="contact-card">
            <div className="contact-icon">
              <i className="fas fa-envelope"></i>
            </div>
            <h3>Email Us</h3>
            <p>
              <a href={`mailto:${contactInfo.email_primary}`}>{contactInfo.email_primary}</a>
            </p>
            {contactInfo.email_secondary && (
              <p>
                <a href={`mailto:${contactInfo.email_secondary}`}>{contactInfo.email_secondary}</a>
              </p>
            )}
          </div>

          <div className="contact-card">
            <div className="contact-icon">
              <i className="fas fa-phone"></i>
            </div>
            <h3>Call Us</h3>
            <p>
              <a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}>{contactInfo.phone}</a>
            </p>
          </div>

          <div className="contact-card">
            <div className="contact-icon">
              <i className="fas fa-globe"></i>
            </div>
            <h3>Visit Website</h3>
            <p>
              <a href={`https://${contactInfo.website}`} target="_blank" rel="noopener noreferrer">
                {contactInfo.website}
              </a>
            </p>
          </div>

          {contactInfo.address && (
            <div className="contact-card full-width">
              <div className="contact-icon">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <h3>Our Address</h3>
              <p>{contactInfo.address}</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ContactInfo;
